import { render, staticRenderFns } from "./claimCommentsList.vue?vue&type=template&id=ef804cde&scoped=true"
import script from "./claimCommentsList.vue?vue&type=script&lang=js"
export * from "./claimCommentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef804cde",
  null
  
)

export default component.exports